import { render } from "./MonEybox.vue?vue&type=template&id=618c01a2"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/MonEybox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "618c01a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('618c01a2', __exports__)) {
    api.reload('618c01a2', __exports__)
  }
  
  module.hot.accept("./MonEybox.vue?vue&type=template&id=618c01a2", () => {
    api.rerender('618c01a2', render)
  })

}


export default __exports__